import { Injectable } from '@angular/core';
import { Customer, CustomerDetailsTab } from 'gung-standard';
import { JeevesCustomerDetailsConfigService } from 'gung-standard-jeeves';
import { GungUser as User } from 'gung-standard';
import { Observable, of, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TyloCustomerDetailsConfigService extends JeevesCustomerDetailsConfigService {
  getCustomerDetailsGungTabs(customer: Customer, roles: string[], user?: User): Observable<CustomerDetailsTab[]> {
    const isUser: boolean = roles.includes('USER') && roles.length === 1;

    return super.getCustomerDetailsGungTabs(customer, roles, user).pipe(
      switchMap(tabs => {

        if (customer.id === 'E0496' && isUser) {
          const index = tabs.findIndex(t => t.id === 'tab-users')
          if (index > -1) {
            tabs.splice(index, 1);
          }
        }

        return of(tabs);
      })
    );
  }
}
